const config = {
  MUNDIPAGG_PK: process.env.MUNDIPAGG_PK || 'pk_test_4VeWzJdUrtEZmxo5',
  API_URL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:3500',
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'local',
  WORKERS_URL: process.env.REACT_APP_WORKERS_URL || 'https://workers.thecalclab.com',
  CDN_URL: process.env.REACT_APP_CDN_URL || 'https://cdn.calclab.com.br',
  RECAPTCHA_TOKEN:
    process.env.REACT_APP_RECAPTCHA_TOKEN || '6LfqP1IaAAAAAMHV_9JdxVu7shHcmaKnhBmSytSf',
  SITE_NAME: 'CalcLab',
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || '2993745040682533',
  GOOGLE_CLIENT_ID:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    '693977557867-ud4dnuf5aic4f2769ouv3or32fff6kee.apps.googleusercontent.com'
}

export default config
